import React from 'react';
import { CONFIRMED_MEETINGS_TAB, REQUESTED_MEETINGS_TAB, SENT_MEETINGS_TAB, ALL_MEETINGS_TAB, VALID_TABS } from './tabs';
import RelativeRedirect from '../../../elements/RelativeRedirect';
import WaitWhileBusy from '../../../WaitWhileBusy';
import AllMeetings from './tabContent/AllMeetings';
import RequestedMeetings from './tabContent/RequestedMeetings';
import SentMeetings from './tabContent/SentMeetings';
import ConfirmedMeetings from './tabContent/ConfirmedMeetings';
import { useEvent } from '../../../../data/hooks/eventHooks';
import MeetingsScreenHeader from './MeetingsScreenHeader';
import CommonMeetingsFooter from '../common/CommonMeetingsFooter';
import Scrollable from '../../../elements/Scrollable';
import Screen from '../../Screen';

const CONTENT_COMPONENTS = {
    [SENT_MEETINGS_TAB]: SentMeetings,
    [REQUESTED_MEETINGS_TAB]: RequestedMeetings,
    [CONFIRMED_MEETINGS_TAB]: ConfirmedMeetings,
    [ALL_MEETINGS_TAB]: AllMeetings,
};

export function EventMeetingsTabbed(props) {
    const { eventId, meetingTab } = props,
        event = useEvent(),
        Content = CONTENT_COMPONENTS[meetingTab];

    if (!Content) return <RelativeRedirect to="../.." />;

    const header = <MeetingsScreenHeader eventId={eventId} meetingTab={meetingTab} />,
        footer = <CommonMeetingsFooter event={event} />;

    return (
        <Screen header={header} footer={footer}>
            <Scrollable>
                <Content {...props} />
            </Scrollable>
        </Screen>
    );
}

export default (props) => (
    <WaitWhileBusy>
        <EventMeetingsTabbed {...props.match.params} />
    </WaitWhileBusy>
);
